import { useStaticQuery, graphql } from "gatsby";

export const getPlaceholderImage = () => {
    const { file } = useStaticQuery<Queries.PlaceholderImageQuery>(graphql`
        query PlaceholderImage {
            file(base: { eq: "image-content-card@2x.jpg" }) {
                childImageSharp {
                    gatsbyImageData
                }
            }
        }
    `);

    return file?.childImageSharp?.gatsbyImageData;
};
